import React from "react";

interface FooterProps {
  privacyPolicyUrl?: string;
  termsUrl?: string;
}

export function Footer({ privacyPolicyUrl, termsUrl }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-gray-900 text-white"
      style={{ paddingBottom: "calc(2rem + 5px)" }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-end gap-4" style={{ minHeight: "40px" }}>
          <p className="text-sm text-gray-400 text-center">
            &copy; {currentYear} Guerilla Teaching. All rights reserved.
          </p>

          {(privacyPolicyUrl || termsUrl) && (
            <div className="flex gap-6">
              {privacyPolicyUrl && (
                <a
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              )}
              {termsUrl && (
                <a
                  href={termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Terms & Conditions
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
